var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirmation-button"
  }, [_c('common-button', {
    staticClass: "confirmation-button__button",
    attrs: {
      "icon": _vm.icon,
      "size": _vm.size,
      "type": _vm.type
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52fb7efc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ConfirmationButton.vue
// module id = 1987
// module chunks = 0